import React from 'react';
import STRINGS from './../../data/language/language';
import EmptyList from '../../components/emptyList/EmptyList';


export default class PagePagamentos extends React.Component{
  constructor(props) {
    super(props);

    this.state = {
      strings: STRINGS[window.LANGUAGE]
    };
  }

  componentDidMount() {

  }

  render(){
    const strings = this.state.strings;
    let pagamentos = <EmptyList />;
console.log(this.props.data.pagamentos);
    if(this.props.data.pagamentos){
      pagamentos = this.props.data.pagamentos.map((value, i) =>
          <div class="item-relatorio">
            <div>Data: {value.data}</div>
            <div>Tipo: {value.tipo_adesao}</div>
            <div>Valor: {value.valor}</div>
          </div>
        );
        console.log(pagamentos);
    }

    return(
      <div>
      {pagamentos}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/clientes/PagePagamentos.js